'use client';

import { __assign } from '../../_virtual/_tslib.js';
import React__default, { useMemo, useCallback } from 'react';
import '../../Images/AddIcon/index.js';
import '../../Images/AddOutlinedIcon/index.js';
import '../../Images/Trash/index.js';
import '../../Images/Pencil/index.js';
import ArrowDownIcon from '../../Images/ArrowDownIcon/index.js';
import '../../Images/ArrowRoundedLeft/index.js';
import '../../Images/ArrowRoundedRight/index.js';
import '../../Images/AwardsIcon/index.js';
import '../../Images/BonusIcon/index.js';
import '../../Images/CanteenIcon/index.js';
import '../../Images/CheckTagIcon/index.js';
import '../../Images/CommercialIcon/index.js';
import '../../Images/CompanySizeIcon/index.js';
import '../../Images/ContactIcon/index.js';
import '../../Images/CopyIcon/index.js';
import '../../Images/DefaultAvatar/index.js';
import '../../Images/DangerIcon/index.js';
import '../../Images/ExternalLinkIcon/index.js';
import '../../Images/FacebookIcon/index.js';
import '../../Images/ForwardIcon/index.js';
import '../../Images/HealthcarePlanIcon/index.js';
import '../../Images/HeartIcon/index.js';
import '../../Images/HeartOutlineIcon/index.js';
import '../../Images/HideIcon/index.js';
import '../../Images/KindergartenIcon/index.js';
import '../../Images/LaptopIcon/index.js';
import '../../Images/LibraryIcon/index.js';
import '../../Images/LinkIcon/index.js';
import '../../Images/LinkedInIcon/index.js';
import '../../Images/LoadingCircleIcon/index.js';
import '../../Images/MarkerIcon/index.js';
import '../../Images/MobileIcon/index.js';
import '../../Images/PaidLeaveIcon/index.js';
import '../../Utils/constants.js';
import '../../Images/SearchIcon/index.js';
import '../../Images/ShareIcon/index.js';
import '../../Images/ReportIcon/index.js';
import '../../Images/StatsIcon/index.js';
import '../../Images/TeamActivitiesIcon/index.js';
import '../../Images/ThreeDotIcon/index.js';
import '../../Images/TrainingIcon/index.js';
import '../../Images/TransportationIcon/index.js';
import '../../Images/TrashIcon/index.js';
import '../../Images/TravelOpportunitiesIcon/index.js';
import '../../Colors/index.js';
import '../../Images/VerticalMoreIcon/index.js';
import '../../Images/VoucherIcon/index.js';
import '../../Images/WowCVIcon/index.js';
import '../../Images/WorkingLocationIcon/index.js';
import '../../Images/ZaloIcon/index.js';
import '../../Images/FacebookLogoIcon/index.js';
import '../../Images/GoogleLogoIcon/index.js';
import '../../Images/DragReorderIcon/index.js';
import '../../Images/CheckIcon/index.js';
import '../../Images/CircleChecked/index.js';
import '../../Images/SalaryIcon/index.js';
import '../../Images/BriefcaseIcon/index.js';
import '../../Images/GraduationCapIcon/index.js';
import '../../Images/EnvelopeIcon/index.js';
import '../../Images/AddFilledIcon/index.js';
import '../../Images/HomeIcon/index.js';
import '../../Images/PhoneIcon/index.js';
import '../../Images/AttachIcon/index.js';
import '../../Images/FilterIcon/index.js';
import '../../icons/WarnIcon.js';
import '../../icons/AccountSettingsIcon.js';
import '../../icons/DashboardIcon.js';
import '../../icons/JobAlertsIcon.js';
import '../../icons/MyCompaniesIcon.js';
import '../../icons/MyJobsIcon.js';
import '../../icons/MyProfileIcon.js';
import '../../icons/ProfileSettingsIcon.js';
import '../../icons/LanguageIcon.js';
import '../../icons/BenefitGroupIcons/ActivityIcon.js';
import '../../icons/BenefitGroupIcons/AwardsIcon.js';
import '../../icons/BenefitGroupIcons/BonusIcon.js';
import '../../icons/BenefitGroupIcons/CanteenIcon.js';
import '../../icons/BenefitGroupIcons/HealthcareIcon.js';
import '../../icons/BenefitGroupIcons/KindergartenIcon.js';
import '../../icons/BenefitGroupIcons/LaptopIcon.js';
import '../../icons/BenefitGroupIcons/LibraryIcon.js';
import '../../icons/BenefitGroupIcons/MoreIcon.js';
import '../../icons/BenefitGroupIcons/PaidLeaveIcon.js';
import '../../icons/BenefitGroupIcons/PhoneIcon.js';
import '../../icons/BenefitGroupIcons/TrainingIcon.js';
import '../../icons/BenefitGroupIcons/TransportationIcon.js';
import '../../icons/BenefitGroupIcons/TravelIcon.js';
import '../../icons/BenefitGroupIcons/VoucherIcon.js';
import '../../icons/BenefitGroupIcons/Physics.js';
import '../../icons/BenefitGroupIcons/WorkingHourIcon.js';
import '../../icons/BenefitGroupIcons/WorkingDayIcon.js';
import '../../icons/BenefitGroupIcons/WorkingTypeIcon.js';
import '../../icons/AccountCenterGroupIcons/ChartVertical.js';
import '../../icons/AccountCenterGroupIcons/Language.js';
import '../../icons/AccountCenterGroupIcons/EmptyHotCategory.js';
import '../../icons/AccountCenterGroupIcons/Lawyer.js';
import '../../icons/InfoOverviewGroupIcons/CompanySize.js';
import '../../icons/InfoOverviewGroupIcons/Location.js';
import '../../icons/InfoOverviewGroupIcons/Education.js';
import '../../icons/InfoOverviewGroupIcons/PhoneNumber.js';
import '../../icons/InfoOverviewGroupIcons/CalendarIOS16Glyph.js';
import '../../icons/InfoOverviewGroupIcons/Admin.js';
import '../../icons/InfoOverviewGroupIcons/HeadHunter.js';
import '../../icons/InfoOverviewGroupIcons/Address.js';
import '../../icons/InfoOverviewGroupIcons/Salary.js';
import '../../icons/InfoOverviewGroupIcons/Gender.js';
import '../../icons/InfoOverviewGroupIcons/Translator.js';
import '../../icons/InfoOverviewGroupIcons/Birthday.js';
import '../../icons/InfoOverviewGroupIcons/LocationIOS16Glyph.js';
import '../../icons/InfoOverviewGroupIcons/CreditIcon.js';
import '../../icons/MiscGroupIcons/Link.js';
import '../../icons/MiscGroupIcons/History.js';
import '../../icons/MiscGroupIcons/Favorite.js';
import '../../icons/MiscGroupIcons/UnFavorite.js';
import '../../icons/MiscGroupIcons/ProductDocuments.js';
import '../../icons/MiscGroupIcons/Star.js';
import '../../icons/SocialMediaGroupIcons/Facebook.js';
import '../../icons/SocialMediaGroupIcons/Linkedin.js';
import '../../icons/SocialMediaGroupIcons/Twitter.js';
import '../../icons/SocialMediaGroupIcons/Zalo.js';
import '../../icons/SocialMediaGroupIcons/FacebooksColorFull.js';
import '../../icons/SocialMediaGroupIcons/LinkedinColorFull.js';
import '../../icons/SocialMediaGroupIcons/TwitterColorFull.js';
import '../../icons/SocialMediaGroupIcons/ZaloColorFull.js';
import '../../icons/SocialMediaGroupIcons/Share.js';
import '../../icons/NavigationGroupIcons/Vertical.js';
import '../../icons/NavigationGroupIcons/More.js';
import '../../icons/NavigationGroupIcons/Close.js';
import '../../icons/NavigationGroupIcons/Expand.js';
import '../../icons/NavigationGroupIcons/Collapse.js';
import '../../icons/NavigationGroupIcons/Next.js';
import '../../icons/NavigationGroupIcons/Back.js';
import '../../icons/NavigationGroupIcons/ExternalLink.js';
import '../../icons/NavigationGroupIcons/RightArrow.js';
import '../../icons/AlertGroupIcons/SuccessIcon.js';
import '../../icons/AlertGroupIcons/CareerPath.js';
import '../../icons/AlertGroupIcons/Hot.js';
import '../../icons/AlertGroupIcons/Urgent.js';
import '../../icons/FormActionGroupIcons/Exchange.js';
import '../../icons/FormActionGroupIcons/AddTag.js';
import '../../icons/RewardsTypeGroupIcons/Hospital.js';
import '../../Images/DoubleTickIcon/index.js';
import '../../Images/BellIcon/index.js';
import '../../Images/AiIcon/index.js';
import '../../Images/MiniAiIcon/index.js';
import '../../icons/OrderManagementIcon.js';
import '../../Images/TwinkleLinearGradientIcon/index.js';
import TextField from '../../TextField/index.js';
import MultiLevelDropdown from '../MultiLevelDropdown/index.js';
import MultiLevelPopup from '../MultiLevelPopup/index.js';
import { INITIAL_FLOATING_CONFIG, INITIAL_DROPDOWN_STYLES } from '../constants.js';
import { MultiLevelSelectContext } from '../store.js';
import { createTranslator } from '../../Utils/helpers.js';
import '../../Cascader/constants.js';
import translations from '../translations.js';

function MultiLevelSelect(_a) {
    var values = _a.values, _b = _a.placeholder, placeholder = _b === void 0 ? 'Select...' : _b, options = _a.options, dropdown = _a.dropdown, onChange = _a.onChange, children = _a.children, _c = _a.fieldValue, fieldValue = _c === void 0 ? 'name' : _c, _d = _a.fieldKey, fieldKey = _d === void 0 ? 'id' : _d, floatingConfig = _a.floatingConfig, onBlur = _a.onBlur, _e = _a.type, type = _e === void 0 ? 'dropdown' : _e, langCode = _a.langCode, _f = _a.hasError, hasError = _f === void 0 ? false : _f, _g = _a.separate, separate = _g === void 0 ? '/ ' : _g;
    var _floatingConfig = __assign(__assign({}, INITIAL_FLOATING_CONFIG), floatingConfig);
    var _dropdown = __assign(__assign({}, INITIAL_DROPDOWN_STYLES), dropdown);
    /**
     * Render
     * */
    var renderValues = useMemo(function () { return (values ? values.map(function (value) { return value[fieldValue]; }) : []); }, [values, fieldValue]);
    var renderChildren = useCallback(function (_a) {
        var isShow = _a.isShow, onToggle = _a.onToggle;
        return children ? (children({ onToggle: onToggle, isShow: isShow })) : (React__default.createElement(TextField, { id: 'multi-level-select', value: renderValues.join(separate), placeholder: placeholder, allowClear: false, type: 'button', suffix: React__default.createElement(ArrowDownIcon, null), onClick: onToggle, isFocus: isShow, hasError: hasError }));
    }, [children, renderValues, separate, placeholder, hasError]);
    return (React__default.createElement(MultiLevelSelectContext.Provider, { value: {
            values: values,
            placeholder: placeholder,
            options: options,
            dropdown: _dropdown,
            onChange: onChange,
            fieldValue: fieldValue,
            fieldKey: fieldKey,
            floatingConfig: _floatingConfig,
            onBlur: onBlur,
            langCode: langCode,
            translate: createTranslator({ translations: translations, currentLanguage: langCode }),
            hasError: hasError,
            separate: separate
        } },
        type === 'dropdown' ? React__default.createElement(MultiLevelDropdown, { renderReference: renderChildren }) : null,
        type === 'popup' ? React__default.createElement(MultiLevelPopup, { renderReference: renderChildren }) : null));
}

export { MultiLevelSelect as default };
//# sourceMappingURL=index.js.map
